const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c1330e20430d71f94d8a49add1726fdb794595c6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["front@saweria"]={id:"c1330e20430d71f94d8a49add1726fdb794595c6"};
      